<section class="section section-shaped">
  <div class="container">
    <div class="text-primary text-underline cursor-pointer back-button h5" (click)="back()">
      {{ 'common.back' | translate }}
    </div>
    <div class="title text-center">{{ 'raise.onePagerPreview' | translate }}</div>

    @if (isLoading) {
      <agmo-loading></agmo-loading>
    }

    @if (!isLoading && summary) {
      <div class="one-pager-content">
        @for (field of fields; track trackByField($index, field); let i = $index) {
          <div class="field-section" [class.slide-section]="field.slideUrl">    
            @switch (field.fieldType) {
              @case (1) {
                <div class="field-description">
                  <div class="field-description-text">
                    @if (field.headerName) {
                      <h3 class="field-header text-left">{{ field.headerName }}</h3>
                    }
                    @if (field.textContent) {
                      <div class="field-text" [innerHTML]="field.textContent"></div>
                    }
                  </div>
                  <div class="field-actions">
                    <button class="btn-action btn-reserve">{{ 'campaign.reserveYourInvestment' | translate }}</button>
                    <button class="btn-action btn-find-out">{{ 'campaignSummary.findOutMore' | translate }}</button>
                  </div>
                </div>
              }
              @case (4) {
                @if (field.headerName) {
                  <h3 class="field-header">{{ field.headerName }}</h3>
                }
                @if (field.keyHighlights && field.keyHighlights.length > 0) {   
                  <div class="key-highlights">
                    @for (hl of field.keyHighlights; track hl) {
                      <div class="highlight-card" [style.background]="hl.backgroundColor">
                        <div class="highlight-top-border"></div>
                        <div class="highlight-body">
                          <div class="highlight-icon-circle">
                            <i [ngClass]="'fa ' + getIconName(hl.iconName)"></i>
                          </div>
                          <h4 class="highlight-title">{{ hl.titleText }}</h4>   
                          <p class="highlight-detail">{{ hl.detailText }}</p>   
                        </div>
                      </div>
                    }
                  </div>
                }
              }
              @case (5) {
                <div>
                  @if (field.headerName) {
                    <h3 class="field-header">{{ field.headerName }}</h3>        
                  }
                  @if (field.textContent) {
                    <img [src]="getImageUrl(field.textContent)" [alt]="field.headerName" class="tw-w-full tw-rounded-lg tw-object-cover" style="max-height: 480px;" />
                  }
                </div>
              }
              @case (6) {
                <div>
                  @if (field.headerName) {
                    <h3 class="field-header">{{ field.headerName }}</h3>        
                  }
                  @if (field.textContent) {
                    @if (getVideoEmbedUrl(field.textContent); as videoUrl) {
                      <div class="video-container">
                        <iframe [src]="videoUrl" [title]="field.headerName || 'Video'" loading="lazy" frameborder="0" allowfullscreen class="block-video" style="width: 100%; height: 400px;"></iframe>
                      </div>
                      <a [href]="getWatchUrl(field.textContent)" target="_blank" rel="noopener noreferrer" class="tw-text-sm tw-text-primary tw-underline tw-mt-2 tw-inline-block">Watch video ↗</a>
                    } @else {
                      <a [href]="getWatchUrl(field.textContent)" target="_blank" rel="noopener noreferrer" class="tw-text-primary tw-underline">Watch video ↗</a>
                    }
                  }
                </div>
              }
              @default {
                <div>
                  @if (field.headerName) {
                    <h3 class="field-header">{{ field.headerName }}</h3>        
                  }
                  @if (field.textContent) {
                    <div class="field-text" [innerHTML]="field.textContent"></div>
                  }
                  @if (field.slideUrl) {
                    <div class="slide-container">
                      <iframe
                        [src]="getSafeUrl(field.slideUrl)"
                        frameborder="0"
                        width="100%"
                        height="400"
                        allowfullscreen
                      ></iframe>
                    </div>
                  }
                </div>
              }
            }
          </div>
        }
      </div>
    }
  </div>
</section>
